import { render, staticRenderFns } from "./CombinedDetails.vue?vue&type=template&id=254b1567&scoped=true"
import script from "./CombinedDetails.vue?vue&type=script&lang=js"
export * from "./CombinedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b1567",
  null
  
)

export default component.exports